import { scrollBar2DChartBaseConfig } from '../ChartBaseConfigs'

export const chartConfig = {
  type: 'scrollbar2d',
  width: '100%',
  height: '500',
  dataFormat: 'json',
  dataSource: {
    chart: {
      showHoverEffect: true,
      animation: true,
      canvasBgAlpha: 100,
      maxLabelWidthPercent: 15,
      showLegend: false,
      theme: 'fusion',
      ...scrollBar2DChartBaseConfig
    }
  }
}
